import ActionTypes from "actions/ActionTypes";

const initialState = {
  storeStatistic: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.STORE_STATISTIC_SUCCESS: {
      return {
        ...state,
        storeStatistic: payload.data,
      };
    }
    default:
      return state;
  }
};
